module.exports = __webpack_public_path__ + "img/4.c061c06d.png";